export default __webpack_public_path__ + "static/media/location1024.622dbec4.png";